module.exports = __webpack_public_path__ + "img/scan2.cfe5895e.png";